import React, { Component } from 'react'
import { connect } from 'react-redux'

import { translation } from '../../../utils/helpers'

// Styles
import './estimationslist.scss'

class EstimationsList extends Component {

  constructor (props) {
    super(props)
    this.state = {
    }
  }

  render () {
    if (!this.props.price || !this.props.priceInformation) return null
    const { RefinishTypes, StartTimes, HourPrices, MaterialsShares } = this.props.priceInformation
    const { price: { OrderEstimationRefinishTypeDetails, OrderEstimationStartTimeDetails, OrderEstimationHourPriceDetails, OrderEstimationMaterialsShareDetails } } = this.props

    const renderEstimationTypes = (titleCode, estimationTypes) => {
      if (!estimationTypes || estimationTypes.length === 0) return null

      return (
        <div className='estimationExtent'>
          <strong className='estimationTitle'>{translation(titleCode)}</strong>
          <div>
            {estimationTypes.map((et, key) => <div key={key}>{et.Type || et.Price || et.Share}</div>)}
          </div>
        </div>
      )
    }

    const refTypes = RefinishTypes.filter(rt =>
      !!OrderEstimationRefinishTypeDetails.find(rtd =>
        rt.EstimationRefinishTypeId === rtd.EstimationRefinishTypeId &&
        rtd.IsDeleted !== true
      )
    )
    const strtTimes = StartTimes.filter(st =>
      !!OrderEstimationStartTimeDetails.find(std =>
        st.EstimationStartTimeId === std.EstimationStartTimeId &&
        std.IsDeleted !== true
      )
    )
    const hrPrices = HourPrices.filter(hp =>
      !!OrderEstimationHourPriceDetails.find(hpd =>
        hp.EstimationHourPriceId === hpd.EstimationHourPriceId &&
        hpd.IsDeleted !== true
      )
    )
    const matShares = MaterialsShares.filter(ms =>
      !!OrderEstimationMaterialsShareDetails.find(msd =>
        ms.EstimationMaterialsShareId === msd.EstimationMaterialsShareId &&
        msd.IsDeleted !== true
      )
    )

    return (
      <div>
        {renderEstimationTypes('161', refTypes)}
        {renderEstimationTypes('1195', strtTimes)}
        {renderEstimationTypes('419', hrPrices)}
        {renderEstimationTypes('415', matShares)}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
})(EstimationsList)



// WEBPACK FOOTER //
// ./src/app/shared/components/EstimationsList/index.js